import YevmiyeLogDBService from "../../db-services/yevmiyeLogDBService";
import { ILogResponseModel } from "../types";


class YevmiyeLogService {
    private dbService;

    constructor() {
        this.dbService = new YevmiyeLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default YevmiyeLogService;
